import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Order from '../views/Order.vue'
import Order1 from '../views/Order1.vue'
import Order2 from '../views/Order2.vue'
import Pay from '../views/Pay.vue'
import TaskPublish from '../views/TaskPublish.vue'
import TaskDetail from '../views/TaskDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/order',
    name: 'Order',
    component: Order
  },
  {
    path: '/order1',
    name: 'Order1',
    component: Order1
  },
  {
    path: '/order2',
    name: 'Order2',
    component: Order2
  },
  {
    path: '/pay',
    name: 'Pay',
    component: Pay
  },
  {
    path: '/taskPublish',
    name: 'TaskPublish',
    component: TaskPublish
  },
  {
    path: '/taskDetail',
    name: 'TaskDetail',
    component: TaskDetail
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
